<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input class="input-with-select" v-model="params.searchValue" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="演出名称" :value="1"></el-option>
                            <el-option label="演出ID" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
                                <el-option label="首场开演时间" :value="1"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker
                            v-model="datetimerange"
                            type="datetimerange"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            class="fl"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            align="right"
                            unlink-panels
                            >
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div v-if="$utils.have('/photo/confirmUpload')" class="page-btns-box">
            <el-button type="primary" icon="el-icon-plus" size="small" @click="$router.push('/dynamic/photo/add')">上传照片</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="activityId" label="演出ID"></el-table-column>
                <el-table-column prop="activityName" label="演出名称" show-overflow-tooltip min-width="150"></el-table-column>
                <el-table-column prop="startTime" label="首场开演时间" min-width="150"></el-table-column>
                <el-table-column prop="uploadPhotoNum" label="已上传照片数" min-width="120"></el-table-column>
                <el-table-column prop="soldPhotoNum" label="已售出照片数" min-width="120"></el-table-column>
                <el-table-column fixed="right" label="操作" width="260">
                    <template slot-scope="{row} = scope">
                        <el-button v-if="$utils.have('/photo/allPhoto')" type="text" size="small" @click="tabs(`/dynamic/photo/allPhoto/${row.activityId}?activityName=${row.activityName}`)">全部照片</el-button>
                        <el-button v-if="$utils.have('/photo/orderList')" type="text" size="small" @click="tabs(`/dynamic/photo/orderList/${row.activityId}?activityName=${row.activityName}`)">销售明细</el-button>
                        <el-button v-if="$utils.have('/photo/tags')" type="text" size="small" @click="tabs(`/dynamic/photo/tags/${row.activityId}?activityName=${row.activityName}`)">标签管理</el-button>
                        <el-button v-if="$utils.have('/photo/setPrice')" type="text" size="small" @click="$refs.setPrice.show(row)">设置售价</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <set-price ref="setPrice" @onUpdate="getDataList"></set-price>
    </div>
</template>

<script>
import SetPrice from './components/SetPrice.vue';
const defaultParams = {
    pageNo:1,
    searchType: 1, //查询类型 1：演出名称 2：演出id
    searchValue: "",
    endTime: "",
    startTime: "",
    timeType: 1,
}
export default {
    components: { SetPrice},
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || "",
                timeType: parseInt(this.$route.query.timeType || 1),
            },
            listLoading: true,
            datetimerange: [this.$route.query.startTime || '' , this.$route.query.endTime || ''],
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.params = {
                ...this.params,
                startTime:this.datetimerange && this.datetimerange[0] || '',
                endTime:this.datetimerange && this.datetimerange[1] || ''
            }
            this.listLoading = true;
            this.$request({
                url: "/photo/list",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
				} else {
                    this.data = null;
					this.dataList = [];
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },

        
        tabs(uri){
            this.$router.push({
                path: `${uri}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        {
                            ...this.params,
                        }
                    )
                },
            });
        },
        
    }
}
</script>

<style lang="scss" scoped>

</style>